package com.siriusxm.pia.views.mddb

import androidx.compose.runtime.Composable
import com.siriusxm.cmc.utils.Route
import com.siriusxm.pia.ApplicationContext
import com.siriusxm.pia.ConsoleApplication
import com.siriusxm.pia.components.serviceView

/**
 * The MDDB application definition.
 */
class MDDBApplication : ConsoleApplication {
    lateinit var mddbAPI: MddbAPI
    lateinit var context: ApplicationContext

    override suspend fun initialize(context: ApplicationContext) {
        this.context = context
        mddbAPI = MddbAPI(context.configuration.mddbApiUrl, context)
    }

    @Composable
    override fun route(route: Route) {
        serviceView {
            mddbDashboardPage(context, mddbAPI)
        }
    }
}